function SvgComponent(props: any) {
    
    return (
        <svg
            width={16}
            height={15}
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect
            x={0.575684}
            y={0.5}
            width={14}
            height={14}
            rx={7}
            stroke={props.isHover ? "#B42318" : "#ADB5BD"}
        />
        <path
            d="M11.326 3.75l-7.5 7.5m0-7.5l7.5 7.5"
            stroke={props.isHover ? "#B42318" : "#ADB5BD"}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
    )
}

export default SvgComponent